"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Alert_1 = require("@rahtab/ui/dist/components/Alert");
const expo_font_1 = require("expo-font");
const SplashScreen = __importStar(require("expo-splash-screen"));
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const store_1 = require("./network-redux/store");
SplashScreen.preventAutoHideAsync();
/**
 * @todo replace fonts prefix with System*
 */
const fonts = {
    'IranYekan-FD-Regular': require('../assets/fonts/iranyekanwebregularfanum.ttf'),
    'IranYekan-FD-Medium': require('../assets/fonts/iranyekanwebmediumfanum.ttf'),
    'IranYekan-FD-Bold': require('../assets/fonts/iranyekanwebboldfanum.ttf'),
};
const SystemProvider = (props) => {
    const { children, reducers } = props;
    const store = react_1.useMemo(() => store_1.storeCreator(reducers), [reducers]);
    const [isFontsLoaded] = expo_font_1.useFonts(fonts);
    react_1.useEffect(() => {
        if (isFontsLoaded)
            SplashScreen.hideAsync();
    }, [isFontsLoaded]);
    if (!isFontsLoaded)
        return null;
    return (react_1.default.createElement(react_redux_1.Provider, { store: store },
        react_1.default.createElement(Alert_1.AlertProvider, null, children)));
};
exports.default = SystemProvider;
